<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<style>
  body {
    -webkit-text-size-adjust: 100% !important;
  }

  @font-face {
    font-family: 'iconfont';
    /* 字体路径保持不变 */
  }
  .iconfont {
    font-family: 'iconfont' !important;
    font-size: 16px;
    font-style: normal;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>

<script>
  /* global WeixinJSBridge */  // 关键修复点
  (function () {
    if (
            typeof WeixinJSBridge == "object" &&
            typeof WeixinJSBridge.invoke == "function"
    ) {
      handleFontSize();
    } else {
      if (document.addEventListener) {
        document.addEventListener("WeixinJSBridgeReady", handleFontSize, false);
      } else if (document.attachEvent) {
        document.attachEvent("WeixinJSBridgeReady", handleFontSize);
        document.attachEvent("onWeixinJSBridgeReady", handleFontSize);
      }
    }
    function handleFontSize() {
      WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      WeixinJSBridge.on("menu:setfont", function () {
        WeixinJSBridge.invoke("setFontSizeCallback", { fontSize: 0 });
      });
    }
  })();
</script>
